// Canonical badge-filename aliases for team names.
//
// The stats.com API returns team display names that don't always match the badge
// asset filenames (FIFA-official vs colloquial names, World Cup national-team
// spelling/punctuation variants). This map translates the *normalized* team name
// (the output of formatTextForAssetNames) to the canonical badge filename basename
// that actually exists under assets/teams/badges and assets/teamBadges.
//
// Used by both FantasyHelpers and Helpers. Keys = possible normalized API names;
// values = existing canonical basename. To support a new variant, add one line.
export const teamBadgeAliases = {
    // World Cup national-team spelling / punctuation variants
    'turkey': 'turkiye',
    'bosnia-herzegovina': 'bosnia-and-herzegovina',
    'bosnia-&-herzegovina': 'bosnia-and-herzegovina',
    'curaçao': 'curacao',

    // FIFA-official vs colloquial national-team names
    'usa': 'united-states',
    'united-states-of-america': 'united-states',
    'south-korea': 'korea-republic',
    'ivory-coast': "cote-d'ivoire",
    "côte-d'ivoire": "cote-d'ivoire",
    'dr-congo': 'congo-dr',
    'democratic-republic-of-the-congo': 'congo-dr',
    'cape-verde': 'cabo-verde',
    'czechia': 'czech-republic',
    'ireland': 'republic-of-ireland',
    'china': 'china-pr',
    'ir-iran': 'iran',
};
